// extracted by css-extract-rspack-plugin
export default {"TitleWrapper":"CodeViewHeader-module__TitleWrapper__u6G68"};